export const watermarkRemover = {
  index: "/watermark-remover",
}; 